import Swiper, { Pagination } from "swiper";

let swiper = new Swiper('.product-images-swiper', {
    slidesPerView: 1,
    modules: [Pagination],
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
});